import { useEffect, useState, useRef } from 'react';
import { callApp } from '../../utils/callApp';
import './index.css'

export enum VIDEOAD_CODE {
    BEGIN = 10001,
    PLAYING = 10002,
    CLOSE = 10003,
    PLAYFULLFILL = 10004,
    PLAYDROPOUT = 10005,
    ERROR = 10006
}

const VideoAd = (props: {visible: boolean, adInfo: {adUrl: string, adPlaySeconds: number}}) => {
    const videoRef = useRef<null | HTMLVideoElement>(null)
    const [countdown, setCountdown] = useState(0)
    const [showVideoAd, setShowVideoAd] = useState(false)
    const [adInfo, setAdInfo] = useState<{adUrl: string, adPlaySeconds: number} | null>(null)
    const interval = useRef<string | number | NodeJS.Timeout>(null!)
    const [playButtonShow, setPlayButtonShow] = useState(false)
    const [isMute, setIsmute] = useState(true)
    const firstPlayed = useRef(false)
    const [isShowConfirm, setIsShowConfirm] = useState(false)
    const [videoVisible, setVideoVisible] = useState(true)

    // useEffect(() => {
    //     setAdInfo(props.adInfo)
    //     setShowVideoAd(props.visible)
    // }, [props])

    useEffect(() => {
        if (!props.adInfo?.adUrl) return
        setAdInfo(props.adInfo)
    }, [props.adInfo])

    useEffect(() => {
        setShowVideoAd(props.visible)
        // 初始化firstPlayed.current
        if (props.visible) {
            firstPlayed.current = false
        }
    }, [props.visible])

    useEffect(() => {
        if (showVideoAd) {
            setVideoVisible(true)
            setIsmute(true)
            setCountdown(adInfo?.adPlaySeconds??30)
            videoRef.current?.play()
            ?.then(() => {
                interval.current = setInterval(() => {
                    setCountdown(pre => pre - 1)
                }, 1000)
            })
            ?.catch((e) => {
                console.log('play error', e)
                setPlayButtonShow(true)
            })
        }
        else {
            interval.current && clearInterval(interval.current)
            setPlayButtonShow(false)
            setIsmute(true)
        }
    }, [showVideoAd])

    useEffect(() => {
        if (countdown <= 0) {
            clearInterval(interval.current)
        }
    }, [countdown])

    const clickPlay = () => {
        setPlayButtonShow(false)
        videoRef.current?.play()
        setCountdown(adInfo?.adPlaySeconds??30)
        interval.current = setInterval(() => {
            setCountdown(pre => pre - 1)
        }, 1000)
    }

    const changeVideoAdShow = (b: boolean) => {
        setShowVideoAd(b)
    }

    const close = () => {
        if(countdown>0){
            interval.current && clearInterval(interval.current)
            setIsShowConfirm(true)
            videoRef.current?.pause()
            setVideoVisible(false)
            return;
        }
        changeVideoAdShow(false)
        if (videoRef.current) {
            videoRef.current.currentTime = 0
            videoRef.current.pause()
        }
        callApp(VIDEOAD_CODE.CLOSE, {removeDelay: 1000})
    };

    const onplay = (e: any) => {
        console.log('onplay+++++', e)
        if (!firstPlayed.current) {
            callApp(VIDEOAD_CODE.BEGIN)
            firstPlayed.current = true
        }
    }

    const onerror = (e: any) => {
        console.log('onerror+++++', e)
        callApp(VIDEOAD_CODE.ERROR)
    }

    const oncanplay = (e: any) => {
        console.log('eroncanplayror+++++', e)
    }

    const changeMuteStatus = () => {
        setIsmute(pre => !pre)
    }

    const onClose = () => {
        // 关闭提示弹窗
        console.log('关闭提示弹窗')
        setVideoVisible(true)
        setIsShowConfirm(false)
        videoRef.current?.play().then(() => {
            interval.current = setInterval(() => {
                setCountdown(pre => pre - 1)
            }, 1000)
        })
      };
    
      const onClose2= () => {
        // 关闭激励视频
        console.log('关闭激励视频')
        setVideoVisible(true)
        setIsShowConfirm(false)
        changeVideoAdShow(false)
        if (videoRef.current) {
            videoRef.current.currentTime = 0
            videoRef.current.pause()
        }
        callApp(VIDEOAD_CODE.CLOSE, {removeDelay: 1000})
      };

    return <>
            {/* <div className="video-ad" style={{width: '100vw', height: '100vh'}}> */}
                <div
                    // className={`${this.showVideoAd ? "bottom-to-top" : 'hide-in-ground'}`}
                    style={{
                        width: '100vw', height: '100vh', position: 'fixed',
                        left: 0, background: '#000', overflow: 'hidden',
                        top: `${showVideoAd ? 0 : '150vh'}`,
                        transition: 'top 0.2s ease-in-out', display: 'flex', flexDirection: 'column'
                    }}
                >
                 {isShowConfirm &&  <div className="popup-modal-overlay">  
                        <div className="popup-modal">  
                            <div className="modal-content">  
                            <p>再看  
                                <span  className='redText'>{countdown}秒</span>，即可获得<span className='redText'>奖励</span></p>  
                            <p>
                                <button onClick={onClose} className="close-button">  
                                留下看看  
                                </button> 
                            </p> 
                            <p>
                                <button onClick={onClose2} className="close-button2">  
                                残忍离开
                                </button> 
                            </p> 
                            </div>  
                        </div>  
                        </div> }

                    <div style={{width: '100%', flex: 1, background: '#000', position: 'relative', display: 'flex', justifyContent: 'center'}}>
                        <div style={{ display: 'flex', flexDirection: 'column', position: 'relative'}}>
                            <div className="videoad-action-wrap">
                                <div className="videoad-reward">
                                    <div className="videoad-reward-name">广告</div>
                                    <div className="videoad-reward-result">{countdown <= 0 ? '成功领取奖励' : `${countdown}秒后可领取奖励`}</div>
                                </div>
                                <div className='videoad-action'>
                                    <div onClick={changeMuteStatus} className={isMute ? `videoad-muted` : 'videoad-not-muted'}></div>
                                    <div
                                        className="videoad-close"
                                        onClick={close}
                                    >关闭</div>
                                </div>
                            </div>
                            <video
                                ref={videoRef}
                                onPlay={onplay}
                                onError={onerror}
                                onCanPlay={oncanplay}
                                playsInline
                                webkit-playsinline="true"
                                x5-playsinline="true"
                                preload="auto"
                                // autoplay
                                muted={isMute}
                                // loop
                                // crossOrigin="anonymous"
                                // x5-video-player-type="h5-page"
                                // x5-video-player-fullscreen="true"
                                style={{height: 'calc(100vh - 55px)', background: '#000', maxWidth: '100vw', visibility: videoVisible ? 'visible' : 'hidden'}}
                                // src="https://pubsdkh5-ltcs-res-cdn.iwgame.com/tttt.mov"
                                src={adInfo?.adUrl || ''}
                            >
                            </video>
                            {playButtonShow && <div className='play-area'>
                                <div className='play-button' onClick={clickPlay}></div>
                                <div className='play-tips'>首次进入请点击播放按钮</div>
                            </div>}
                        </div>
                    </div>
                </div>
            {/* </div> */}
        </>

}

export default VideoAd;